import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { numberRegex } from 'src/app/resources/Constants';

@Component({
    selector: 'app-edit-value-modal',
    templateUrl: './edit-value-modal.component.html',
    styleUrls: ['./edit-value-modal.component.scss'],
    standalone: false
})
export class EditValueModalComponent implements OnInit {

  @Input() cellValue: string;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() inputLabel: string;
  @Output() closeModal: EventEmitter<string> = new EventEmitter();
  valid: string;
  formEditValue: UntypedFormGroup;
  submitted = false;
  regexForNumber = numberRegex;

  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: UntypedFormBuilder) { }

  ngOnInit() {
    this.formEditValue = this.formBuilder.group({
      inputValue: [this.cellValue, [Validators.required, Validators.pattern(this.regexForNumber)]]
    });
  }

  /**
   * Get the form
   */

  get form() { return this.formEditValue.controls; }

  /**
   * Modal submit. Send the value entered into the input,
   * replacing the point with a comma
   */

  onSubmit() {
    this.submitted = true;

    if (this.formEditValue.invalid) { return; }

    this.closeModal.emit(this.formEditValue.value.inputValue.replace('.', ','));
    this.activeModal.close();
  }

}
